<template>
  <div>
    <!-- 轮播图Loading -->
    <a-spin tip="Loading..." :spinning="bannerIsLoading" size="large" style="position: absolute;top: 25%;left: 49%;"/>
    <!-- 轮播图 -->
    <swiper  class="header-bgaimg" :options="swiperOption">
      <swiper-slide v-for="(item, index) in banner" :key="index">
        <template v-if="item.jumpUrl">
          <a :href="'https://'+item.jumpUrl" target="_blank"><img style="max-width:100%;height: 524px;object-fit:cover;" :src="item[
          'bannerUrl' + bannerCode[currentLang]]" alt=""></a>
        </template>
        <template v-else>
          <div>
            <img style="max-width:100%;height: 524px;object-fit:cover;" :src="item['bannerUrl' + bannerCode[currentLang]]" alt="">
          </div>
        </template>
      </swiper-slide>
      <div class="swiper-pagination"  slot="pagination"></div>
    </swiper>
    <!-- 介绍 -->
    <div class="LoginContent">
      <div class="LoginContent-lifespan">
        <img src="@/assets/s1.png" alt=""/>
        <div class="LoginContent-title">{{$t('pageHome_成为开发者')}}</div>
        <div class="LoginContent-detail" :class="currentLang === 'zh_CN' ? '':'LoginContent-13'">
          {{$t('pageHome_易仓开放平台为拥有开发能力的易仓商户和第三方开发者提供API接口形式的基础服务')}}<br>{{$t('pageHome_支持客户根据自身流程及运营情况自身流程及运营情')}}<br>
          {{$t('pageHome_让您的软件系统成为跨境卖家的最优选择，提升核心竞争力')}}</div>
      </div>
      <div class="LoginContent-lifespan">
        <img src="@/assets/s2.png" alt=""/>
        <div class="LoginContent-title">{{$t('pageHome_基础开发流程')}}</div>
        <div class="LoginContent-detail" :class="currentLang === 'zh_CN' ? '':'LoginContent-13'">{{$t('pageHome_易仓开放平台为开发者提供ERP、海外仓WMS等')}}<br>
          {{$t('pageHome_开放平台API对接使用应用环境说明，包含调用')}}<br>
          {{$t('pageHome_提供各种开发便利，降低开发难度')}}<br>
          {{$t('pageHome_助您轻松实现繁复定制化需求,快速打造特色个性化系统')}}</div>
      </div>
      <div class="LoginContent-lifespan">
        <img src="@/assets/s3.png" alt=""/>
        <div class="LoginContent-title">{{$t('pageHome_对接易仓API')}}</div>
        <div class="LoginContent-detail" :class="currentLang === 'zh_CN' ? '':'LoginContent-13'">{{$t('pageHome_API开发测试工具')}}<br>
          {{$t('pageHome_请求json实时测试请求调用')}}<br>
          {{$t('pageHome_API测试工具')}}<br>
          {{$t('pageHome_帮助开发人员进行build， debug，测试API')}}<br>
          SDK/Demo<br>
          {{$t('pageHome_生成签名，拼接签名串方法说明及实例，助您快速完成对接开发')}}<br>
        </div>
      </div>
    </div>

    <div class="LoginContent-desc">{{$t('pageHome_多种接入方案，满足您的业务需求')}}</div>
    <div class="LoginContent-leader">
      <div :class="{'over': istten === 'erp'}">
        <svg-icon :name="istten === 'erp' ? 'erp-active' : 'erp'" style="width: 18px;"></svg-icon>
        <span @mouseover="istten = 'erp'">
          {{$t('pageHome_易仓商户接入')}}
        </span>
      </div>
      <div :class="{'over': istten === 'serve'}">
        <svg-icon :name="istten === 'serve' ? 'serve-active' : 'serve'" style="width: 18px;"></svg-icon>
        <span @mouseover="istten = 'serve'">
          {{$t('pageHome_软件服务商接入')}}
        </span>
      </div>
      <div :class="{'over': istten === 'isv'}">
        <svg-icon :name="istten === 'isv' ? 'isv-active' : 'isv'" style="width: 18px;"></svg-icon>
        <span @mouseover="istten = 'isv'">
          {{$t('pageHome_ISV接入')}}
        </span>
      </div>
    </div>
    <div class="LoginContent-radius">
      <div class="LoginContent-buis">
        <div class="center" v-for="(item, index) in (istten === 'erp' ? erpList : istten === 'serve' ? severList : isvList)" :key="index">
          <svg-icon :name="item.icon"></svg-icon>
          <!-- <img class="xicon" :src="item.icon" style="position: relative;" /> -->
          <span>{{item.text}}</span>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <!-- <LinkTop :isHome="true"/> -->
    <!-- <Login-tips /> -->
  </div>
</template>
<script>

import { BannerQueryList } from '@/api/login'
import { mapState } from 'vuex'
// import LinkTop from '@/components/LinkTop'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { openNotificationWithIcon } from '@/utils/util'
import Footer from '@/components/Footer'

export default {
  components: {
    // LinkTop,
    swiper,
    swiperSlide,
    Footer
    // 'Login-tips': LoginTips
  },
  data () {
    return {
      banner: [],
      istten: 'serve',
      swiperOption: {
        // 参数选项,显示小点
        pagination: '.swiper-pagination',
        paginationClickable: true, // 小圆点可点击
        // 循环
        loop: true,
        // 每张播放时长3秒，自动播放
        autoplay: 3000,
        // 滑动速度
        speed: 1000
        // delay:1000
      },
      bannerCode: {
        'zh_CN': '',
        'en_US': 'En',
        'ko_KR': 'Kr'
      },
      bannerIsLoading: false,
      severList: [
        {
          icon: 'home-1',
          text: this.$t('pageHome_注册并登录')
        },

        {
          icon: 'home-2',
          text: this.$t('pageHome_完成资质认证')
        },

        {
          icon: 'home-3',
          text: this.$t('pageHome_创建应用')
        },

        {
          icon: 'home-4',
          text: this.$t('pageHome_应用授权')
        },

        {
          icon: 'home-5',
          text: this.$t('pageHome_接口调试')
        },

        {
          icon: 'home-6',
          text: this.$t('pageHome_完成上线')
        }
      ],
      erpList: [
        {
          icon: 'home-1',
          text: this.$t('pageHome_登录易仓账号')
        },

        {
          icon: 'home-3',
          text: this.$t('pageHome_创建应用')
        },

        {
          icon: 'home-5',
          text: this.$t('pageHome_接口调试')
        },

        {
          icon: 'home-6',
          text: this.$t('pageHome_完成上线')
        }
      ],
      isvList: [
        {
          icon: 'home-1',
          text: this.$t('pageHome_注册并登录')
        },

        {
          icon: 'home-2',
          text: this.$t('pageHome_完成资质认证')
        },

        {
          icon: 'home-3',
          text: this.$t('pageHome_创建应用')
        },

        {
          icon: 'home-5',
          text: this.$t('pageHome_接口调试')
        },

        {
          icon: 'home-6',
          text: this.$t('pageHome_上架应用市场')
        }
      ]
    }
  },
  computed: {
    ...mapState({
      currentLang: state => state.isLogin.lang
    })
  },
  mounted () {
    let data = {
      bannerStatus: 1,
      platformCode: 'OPEN_API_PORTAL',
      paging: false
    }
    this.bannerIsLoading = true
    BannerQueryList(data).then((res) => {
      if (res.code === '200') {
        this.banner = res.dataList
      } else {
        openNotificationWithIcon(res.message)
      }
    }).finally(() => {
      this.bannerIsLoading = false
    })
  }
}
</script>
<style lang="less" scoped>
.header-bgaimg {
  width: 100%;
  height: 524px;
  // background: url(../assets/bannar.png) no-repeat top center;
  position: relative;
  background-size: 100% 100%;
}
.LoginContent {
  width: 1200px;
  margin: 0 auto;
  padding-top: 44px;
  display: flex;
  justify-content: space-between;
  .LoginContent-lifespan {
    width:387px;
    min-height:348px;
    padding: 7px 17px;
    background:rgba(255,255,255,1);
    border:1px solid rgba(221,221,221,1);
    img {
      width: 70px;
      height: 70px;
      margin-top: 30px;
      margin-bottom: 15px;
    }
    .LoginContent-title {
      color: #333333;
      font-size: 18px;
      font-weight: 600;
    }
    .LoginContent-detail {
      margin-top: 19px;
      color:rgba(85,85,85,1);
      font-size: 14px;
      line-height:24px;
      text-align: left;
    }
  }
}
.LoginContent-13 {
  font-size: 13px!important; // 英文
}

.LoginContent-leader {
  margin-top: 29px;
  margin-bottom: 60px;
  text-align: center;
  display: flex;
  justify-content: center;
  .over {
    font-size: 16px;
    font-weight: 400;
    position: relative;
    // border-bottom: 2px solid #077BFC;
    // height: 46px;
    span {
      color: #077BFC;
    }
    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 2px;
      background: #077BFC;
      position: absolute;
      top: 46px;
    }
  }
  div {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    height: 46px;
    img {
      margin-right: 3px;
      height: 16px;
    }
  }
  div:not(:first-child) {
    margin-left: 40px;
  }
  span {
    cursor: pointer;
    font-size: 16px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.75);
  }
}

.LoginContent-desc {
  font-size: 32px;
  margin-top: 80px;
  // font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}

.LoginContent-radius {
  width: auto;
  height: 100px;
  margin: 0 auto;
  position: relative;
  margin-bottom: 58px;
  // background: url(../assets/radius.png) no-repeat top center;
  // background-size: 100% 100%;
  .xicon {
    width: 1174px;
    height: 46px;
  }
  .LoginContent-buis {
    width: auto;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .center {
      text-align: center;
      position: relative;
      div {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      svg {
        width: 47px;
        height: 47px;
      }
      &:not(:last-child) {
        margin-right: 158px;
      }
      &:not(:last-child)::after {
        content: '';
        position: absolute;
        left: 61px;
        top: 15px;
        display: inline-block;
        width: 130px;
        height: 18px;
        background: url('~@/assets/home/next.png') no-repeat left center;
      }
      span {
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        white-space: nowrap;
        top: 65px;
      }
    }
  }
}
/deep/ .swiper-pagination-bullet {
  width: 20px;
  height: 3px;
  border-radius: 4px;
  transition: all 0.3s;
}
/deep/ .swiper-pagination-bullet-active {
  width: 40px;
  background: #DDEEFF;
  opacity: 0.75;
}
</style>
